// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class UserMetadataModel {
    static getAttributeTypeMap() {
        return UserMetadataModel.attributeTypeMap;
    }
}
UserMetadataModel.additionalProperties = true;
UserMetadataModel.discriminator = undefined;
UserMetadataModel.attributeTypeMap = [];
//# sourceMappingURL=userMetadataModel.js.map